import { useQuery } from "@tanstack/react-query";
import { getStoredToken } from "@/lib/googleAuth";
import { listFolderChildren, DriveAuthError } from "@/services/googleDriveService";
import {
  useGoogleDriveConnection,
  isDriveAuthError,
} from "@/hooks/googleDrive/useGoogleDriveConnection";

export function useGoogleDriveFolderContents(folderId: string) {
  const { connection, applySession, handleAuthFailure } =
    useGoogleDriveConnection();

  return useQuery({
    queryKey: ["google-drive", "folder", folderId, connection.token],
    queryFn: async () => {
      try {
        const token = connection.token ?? getStoredToken();
        if (!token) {
          throw new DriveAuthError();
        }
        const result = await listFolderChildren(folderId, token);
        const latestToken = getStoredToken();
        if (latestToken && latestToken !== connection.token) {
          applySession(latestToken);
        }
        return result;
      } catch (error) {
        if (isDriveAuthError(error)) {
          handleAuthFailure();
        }
        throw error;
      }
    },
    enabled: connection.driveConnected && !!connection.token,
    staleTime: 60_000,
    retry: (failureCount, error) => {
      if (isDriveAuthError(error)) return false;
      return failureCount < 1;
    },
  });
}
